import type { BrandPurchaser } from "@src/domain/entities/brand";
import type { UpdateBrandPurchaserStatusDTO } from "@src/domain/dto/brands";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export class UpdateBrandPurchaserStatusUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(params: UpdateBrandPurchaserStatusDTO): Promise<BrandPurchaser> {
    try {
      const updatedPurchaser =
        await this.brandRepository.updateBrandPurchaserStatus(params);
      if (!updatedPurchaser) {
        throw new Error("No brand purchaser returned");
      }
      return updatedPurchaser;
    } catch (error) {
      console.error("Failed to update brand purchaser status:", error);
      throw new Error("Failed to update brand purchaser status");
    }
  }
}
